import styled, { css } from 'styled-components';

export const TimeLineContainer = styled.div`
  position: relative;

  & > :last-child {
    min-height: 80px;
  }
`;

export const TimeLineBar = styled.div`
  ${({ theme, height }) => css`
    background: ${theme.v2.colors.gradient.secondary};
    border-radius: 12px;
    position: absolute;
    margin: 0 4px;
    width: 24px;
    height: ${height}px;
    z-index: 0;
  `};
`;

export const TimeLineItem = styled.div`
  display: flex;
  gap: 16px;
  min-height: 90px;
`;

export const TimeLineItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 4px;
`;

export const TimeLineItemTitle = styled.h5`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;

    strong {
      color: ${theme.v2.colors.brand.primaryMedium};
      font-weight: ${theme.v2.font.weights.bold};
    }
  `};
`;

export const TimeLineItemDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;

    strong {
      color: ${theme.v2.colors.brand.primaryExtraDark};
      font-weight: ${theme.v2.font.weights.medium};
    }
  `};
`;

export const TimeLineIcon = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.gradient.secondary};
    border-radius: 50%;
    display: flex;
    height: 32px;
    justify-content: center;
    position: relative;
    max-width: 32px;
    width: 100%;
    z-index: 1;
  `};
`;

export const WhiteTimeLineIcon = styled.div`
  ${({ theme }) => css`
    align-items: center;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    background: white;
    position: relative;
    height: 32px;
    max-width: 32px;
    width: 100%;
    z-index: 0;

    &::before {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border-radius: inherit;
      background: ${theme.v2.colors.gradient.secondary};
      z-index: -1;
    }

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: inherit;
      background: white;
      z-index: -1;
    }
  `};
`;
